import { c as create_ssr_component, v as validate_component } from "./ssr.js";
import { B as BaseButton } from "./PrimaryButton.js";
const SecondaryButton = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { disabled = void 0 } = $$props;
  let { type = "button" } = $$props;
  let { size = void 0 } = $$props;
  let { href = void 0 } = $$props;
  if ($$props.disabled === void 0 && $$bindings.disabled && disabled !== void 0)
    $$bindings.disabled(disabled);
  if ($$props.type === void 0 && $$bindings.type && type !== void 0)
    $$bindings.type(type);
  if ($$props.size === void 0 && $$bindings.size && size !== void 0)
    $$bindings.size(size);
  if ($$props.href === void 0 && $$bindings.href && href !== void 0)
    $$bindings.href(href);
  return `${validate_component(BaseButton, "BaseButton").$$render(
    $$result,
    {
      href,
      type,
      size,
      disabled,
      styles: "font-medium focus:ring-gray-200 border border-gray-200 bg-white"
    },
    {},
    {
      default: () => {
        return `${slots.default ? slots.default({}) : ``}`;
      }
    }
  )}`;
});
export {
  SecondaryButton as S
};
